import { useSelector } from 'react-redux';
import { layeredNoiseWaveForLeadSelector } from '../../wave/selectors/wave.selectors';
import { Waves } from './Waves';
import { useNoiseHandler } from '../../wave/hooks/useNoiseHandler';
import { useStrip } from '../hooks/useStrip';
import { noiseTagFilterSelector } from '../selectors/strip.selectors';

export const NoiseWaves = () => {
  const { leads, stripId } = useStrip();
  const handler = useNoiseHandler();
  const tagFilter = useSelector(noiseTagFilterSelector(stripId));
  const [backgroundWaveIds, foregroundWaveIds] = useSelector(
    layeredNoiseWaveForLeadSelector(leads, tagFilter),
  );

  return (
    <Waves
      handler={handler}
      background={backgroundWaveIds}
      foreground={foregroundWaveIds}
    />
  );
};
